import React from 'react';

import { useParams } from 'react-router';

import { FormProvider } from 'context/FormContext';
import { ListagemProvider } from 'context/ListagemContext';
import { usePermissionsContext } from 'context/PermissionsContext';
import { UsuarioFormComp, UsuarioListComp } from 'pages/cadastro/usuario/components';

export function UsuarioForm() {
    const { hasFormPermission, alertNotPermission } = usePermissionsContext();
    const { id } = useParams();

    if (!hasFormPermission('USUARIO', id)) return alertNotPermission();

    return (
        <FormProvider>
            <UsuarioFormComp />
        </FormProvider>
    );
}

export function UsuarioList() {
    const { hasPermission, alertNotPermission } = usePermissionsContext();

    if (!hasPermission(['USUARIO_VISUALIZAR'])) return alertNotPermission();

    return (
        <ListagemProvider>
            <UsuarioListComp />
        </ListagemProvider>
    );
}
